import usLangLib from '../locales/en_US';

const enLang = {
  messages: {
    ...usLangLib,
  },
  locale: 'en-US',
};
export default enLang;
